export enum LocationTypeEnum {
  BillingLocation = 1,
  ShippingLocation = 2,
  Others = 3,
}
